import React, { useState } from 'react'

import * as Yup from 'yup'
import { Form, Select } from 'formik-antd'
import { TimePicker, Form as FormAntd, List, Button, Input as InputAntd, Select as SelectAntd} from 'antd'
import Moment from 'moment'

import { PlusOutlined } from '@ant-design/icons'

import { BasicForm } from '../../../../core/components/form'
import { useUpdateWorkingHours, useFetch } from '../../../../hooks/admin/settings/workingHours'
import { useHistory } from 'react-router-dom'
import { selectTimezones } from '../../../../core/utils/timezones'
import Loader from '../../../../components/loader'
import { isNotValid, translateSymfonyErrorToFormik } from '../../../../core/utils/form'

const WorkingHoursSchema = Yup.object().shape({
  timezone: Yup.string().required('Cannot be blank.')
})

const getRangeMoment = (range) => {
  if (range) {
    const arr = range.split('-')
    if (arr.length === 2) {
      return [Moment(arr[0], 'HH:mm'), Moment(arr[1], 'HH:mm')]
    }
  }

  return null
}

const getDateRange = (range) => {
  if (range) {
    const from = Moment(range[0]).format('HH:mm')
    const to = Moment(range[1]).format('HH:mm')

    return `${from}-${to}`
  }
  return null
}

const months = [
  { value: '01', label: 'January', max: 31 },
  { value: '02', label: 'February', max: 28 },
  { value: '03', label: 'March', max: 31 },
  { value: '04', label: 'April', max: 30 },
  { value: '05', label: 'May', max: 31 },
  { value: '06', label: 'June', max: 30 },
  { value: '07', label: 'July', max: 31 },
  { value: '08', label: 'August', max: 31 },
  { value: '09', label: 'September', max: 30 },
  { value: '10', label: 'October', max: 31 },
  { value: '11', label: 'November', max: 30 },
  { value: '12', label: 'December', max: 31 }
]

const days = [
  { value: '01', label: '01' },
  { value: '02', label: '02' },
  { value: '03', label: '03' },
  { value: '04', label: '04' },
  { value: '05', label: '05' },
  { value: '06', label: '06' },
  { value: '07', label: '07' },
  { value: '08', label: '08' },
  { value: '09', label: '09' },
  { value: '10', label: '10' },
  { value: '11', label: '11' },
  { value: '12', label: '12' },
  { value: '13', label: '13' },
  { value: '14', label: '14' },
  { value: '15', label: '15' },
  { value: '16', label: '16' },
  { value: '17', label: '17' },
  { value: '18', label: '18' },
  { value: '19', label: '19' },
  { value: '20', label: '20' },
  { value: '21', label: '21' },
  { value: '22', label: '22' },
  { value: '23', label: '23' },
  { value: '24', label: '24' },
  { value: '25', label: '25' },
  { value: '26', label: '26' },
  { value: '27', label: '27' },
  { value: '28', label: '28' },
  { value: '29', label: '29' },
  { value: '30', label: '30' },
  { value: '31', label: '31' }
]

const Formulario = () => {
  const [holidayDay, setHolidayDay] = useState('01')
  const [holidayMonth, setHolidayMonth] = useState('01')

  const { data, isLoading, isError } = useFetch()
  const update = useUpdateWorkingHours()
  const history = useHistory()

  function handleSubmit (values, bag) {
    const form = {
      monday: getDateRange(values.monday),
      tuesday: getDateRange(values.tuesday),
      wednesday: getDateRange(values.wednesday),
      thursday: getDateRange(values.thursday),
      friday: getDateRange(values.friday),
      saturday: getDateRange(values.saturday),
      sunday: getDateRange(values.sunday),
      timezone: values.timezone,
      exceptions: values.exceptions
    }

    update.mutate(form, {
      onSuccess: (data) => {
        bag.setSubmitting(false)
        onPressBack()
      },
      onError: (error, variables, context) => {
        bag.setSubmitting(false)
        if (error.response.status === 400) {
          const data = error.response?.data
          if (isNotValid(data)) {
            bag.setErrors(translateSymfonyErrorToFormik(data?.errors?.children))
          }
        }
      }
    })
  }
  const addHoliday = (setFieldValue, values) => {
    const day = `${holidayMonth}-${holidayDay}`
    const exception = { id: day, value: [], type: 'recurring' }

    const numberDay = Number(holidayDay)
    if (holidayMonth === '02' && numberDay > 28) {
      return
    }

    if (['04', '06', '09', '11'].includes(holidayMonth) && numberDay > 30) {
      return
    }

    const exists = values.exceptions.find(item => item.id === day)
    if (exists) {
      return
    }

    setFieldValue('exceptions', [...values.exceptions, exception])
    setHolidayDay('01')
    setHolidayMonth('01')
  }

  const removeHoliday = (setFieldValue, values, item) => {
    const newExceptions = values.exceptions.filter(e => e.id !== item.id)
    setFieldValue('exceptions', newExceptions)
  }

  const onPressBack = () => history.goBack()

  if (isLoading) {
    return (<Loader loading={isLoading} />)
  }

  if (isError) {
    return (<>Error</>)
  }

  const initialValues = {
    timezone: data.entity.timezone,
    monday: getRangeMoment(data.entity.monday),
    tuesday: getRangeMoment(data.entity.tuesday),
    wednesday: getRangeMoment(data.entity.wednesday),
    thursday: getRangeMoment(data.entity.thursday),
    friday: getRangeMoment(data.entity.friday),
    saturday: getRangeMoment(data.entity.saturday),
    sunday: getRangeMoment(data.entity.sunday),
    exceptions: data.entity.exceptions || []
  }

  return (
    <BasicForm
      onPressBack={onPressBack}
      titulo='Working Hours'
      initialValues={initialValues}
      validationSchema={WorkingHoursSchema}
      onSubmit={handleSubmit}
      render={({ isSubmitting, touched, errors, values, setFieldValue }) => (
        <>
          <Form.Item label='TimeZone' name='timezone' required>
            <Select name='timezone' options={selectTimezones()} showSearch />
          </Form.Item>
          <Form.Item label='Monday' name='monday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.monday}
              onChange={(val) => setFieldValue('monday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Tuesday' name='tuesday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.tuesday}
              onChange={(val) => setFieldValue('tuesday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Wednesday' name='Wednesday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.wednesday}
              onChange={(val) => setFieldValue('wednesday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Thursday' name='Thursday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.thursday}
              onChange={(val) => setFieldValue('thursday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Friday' name='friday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.friday}
              onChange={(val) => setFieldValue('friday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Saturday' name='saturday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.saturday}
              onChange={(val) => setFieldValue('saturday', val)}
              allowClear
            />
          </Form.Item>
          <Form.Item label='Sunday' name='sunday'>
            <TimePicker.RangePicker
              format='HH:mm'
              minuteStep={15}
              value={values.sunday}
              onChange={(val) => setFieldValue('sunday', val)}
              allowClear
            />
          </Form.Item>

          <Form.Item name='exceptions' hidden />

          <FormAntd.Item label='Holiday'>
            <InputAntd.Group compact>
              <FormAntd.Item noStyle>
                <SelectAntd
                  allowClear
                  placeholder='Day'
                  onChange={setHolidayDay}
                  value={holidayDay}
                  options={days}
                  style={{ width: '30%' }}
                />
              </FormAntd.Item>
              <FormAntd.Item noStyle>
                <SelectAntd
                  allowClear
                  placeholder='Month'
                  onChange={setHolidayMonth}
                  value={holidayMonth}
                  options={months}
                  style={{ width: '30%' }}
                />
              </FormAntd.Item>
              <Button
                icon={<PlusOutlined />}
                disabled={holidayDay === '' || holidayMonth === ''}
                onClick={() => addHoliday(setFieldValue, values)}
              >
                Add
              </Button>
            </InputAntd.Group>
            <>
              <br />
              <List
                size='small'
                bordered
                dataSource={values.exceptions}
                renderItem={(item) => (
                  <List.Item
                    key={item.id}
                    actions={[
                      <Button
                        key='delete'
                        type='link'
                        onClick={() => removeHoliday(setFieldValue, values, item)}
                      >
                        delete
                      </Button>
                    ]}
                  >
                    <>
                      <p>YYYY-{item.id}</p>
                    </>
                  </List.Item>
                )}
              />
            </>
          </FormAntd.Item>
        </>
      )}
    />
  )
}

export default Formulario
